import { TransportadoraErp } from "../Components/TransportadoraErp";

export const EditTransportadora = () => {
    return (
        <TransportadoraErp
            isOpen={true}
            onClose={() => navigation.back()}
        />
    )
}